module.exports = __webpack_public_path__ + "static/media/sabage.ee201cb5.jpg";